// Types
import { Action } from 'redux';
import { BaseVisibilityState } from './baseVisibleConnectionState';
import { SOCKET_CONNECT } from '../../utils/socket/socketConstants';
import { VisibleConnectionStatus } from './visibleConnectionStatusTypes';
import { LOGIN_SUCCESS, REGISTER_SUCCESS } from '../../auth/authConstants';

/**
 * The socket isn't connected, but the user is logged out, so don't show
 * any visual indicators.
 */
export class IdleState extends BaseVisibilityState {
    static stateKey = VisibleConnectionStatus.idle;

    nextState(action: Action) {
        switch (action.type) {
            case SOCKET_CONNECT:
                return VisibleConnectionStatus.connected;
            case LOGIN_SUCCESS:
            case REGISTER_SUCCESS:
                return VisibleConnectionStatus.connecting;
            default:
                return undefined;
        }
    }
}
